import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { RolePipe } from 'app/service/pipes/role.pipe';
import { UserStatusPipe } from 'app/service/pipes/userstatus.pipe';
import { NotificationForPipe } from 'app/service/pipes/notificationfor.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    SearchPipe,
    ShortNamePipe,
    RolePipe,
    UserStatusPipe,
    NotificationForPipe,
  ],
  imports: [CommonModule],
  exports: [
    FilterPipe,
    SearchPipe,
    ShortNamePipe,
    RolePipe,
    UserStatusPipe,
    NotificationForPipe,
  ]
})

export class PipeModule { }
